import { cva } from 'class-variance-authority';

export const infoBoxVariants = cva('flex flex-row items-center w-full p-4 gap-4 h-auto', {
  variants: {
    type: {
      outlined: '',
      success: '',
      filledSuccess: '',
      info: '',
      filledInfo: '',
      warning: '',
      filledWarning: '',
      danger: '',
      filledDanger: '',
    },
    size: {
      small: 'min-h-12 p-3',
      medium: 'min-h-[4.188rem] p-4',
      large: 'min-h-20 p-4',
    },
  },
  defaultVariants: {
    type: 'outlined',
    size: 'medium',
  },
});
